import React from "react";
import { Dropdown } from "semantic-ui-react";
import styled from "styled-components";

const DropdownContainer = styled.div`
  margin-top: 50px;
`;

const DropdownWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

interface Props {
  sites: Insite.AppState["userSites"]["sites"];
  setCurrentSite: (syncoId: string) => void;
  currentSite: string;
  disabled: boolean;
}

const SiteDropdown: React.FC<Props> = ({
                                    sites,
                                    setCurrentSite,
                                    currentSite,
                                         disabled
                                  }) => {

  const cardHeader = sites[currentSite]?.label || "Unknown";

  return (
    <DropdownContainer>
      <DropdownWrapper>
        <Dropdown
          disabled={disabled}
          text={cardHeader}
          onChange={(_, data) => {
            setCurrentSite(data.value as string);
          }}
          selection
          options={Object.keys(sites).map((syncoId: string) => ({
            key: sites[syncoId].label,
            value: sites[syncoId].syncoId,
            text: sites[syncoId].label,
          }))}
        />
      </DropdownWrapper>
    </DropdownContainer>
  );
};

export default SiteDropdown;
